import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { FiPlus, FiEdit, FiX } from 'react-icons/fi';

export default function ShopStaff() {
  const [staff, setStaff] = useState([]);
  const [shopType, setShopType] = useState('barber');
  const roleOptions = shopType === 'parlour' ? ['Beautician', 'Senior Beautician', 'Makeup Artist', 'Hair Stylist', 'Manager', 'Assistant'] : shopType === 'dentist' ? ['Dentist', 'Senior Dentist', 'Dental Assistant', 'Receptionist', 'Manager'] : ['Barber', 'Senior Barber', 'Hair Stylist', 'Manager', 'Assistant'];
  const defaultRole = shopType === 'parlour' ? 'Beautician' : shopType === 'dentist' ? 'Dentist' : 'Barber';
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', role: '', is_active: true });
  const [editId, setEditId] = useState(null);
  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  const load = () => axios.get('/api/shop/staff').then(r => setStaff(r.data));
  useEffect(() => { load(); axios.get('/api/shop/profile').then(r => { if (r.data.shop_type) setShopType(r.data.shop_type); }).catch(() => {}); }, []);

  const openAdd = () => { setForm({ name: '', phone: '', role: defaultRole, is_active: true }); setEditId(null); setModal(true); };
  const openEdit = (s) => { setForm({...s, is_active: !!s.is_active}); setEditId(s.id); setModal(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editId) { await axios.put(`/api/shop/staff/${editId}`, form); toast.success('Staff update ho gaya!'); }
      else { await axios.post('/api/shop/staff', form); toast.success('Staff add ho gaya!'); }
      setModal(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };
  const handleDelete = async (s) => {
    if (!window.confirm(`${s.name} ko delete karna hai?`)) return;
    try {
      await axios.delete(`/api/shop/staff/${s.id}`);
      toast.success('Staff delete ho gaya!');
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error');
    }
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="flex-between page-header">
          <div><h1>Staff Members</h1><p>Apne staff members manage karein</p></div>
          <button className="btn btn-primary" onClick={openAdd}><FiPlus /> Staff Add</button>
        </div>

        <div className="grid-3">
          {staff.map(s => (
            <div key={s.id} className="card card-hover">
              <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: '28px' }}>
                  {s.name.charAt(0).toUpperCase()}
                </div>
                <h3 style={{ fontSize: '16px' }}>{s.name}</h3>
                <p style={{ color: 'var(--text-light)', fontSize: '13px' }}>{s.role}</p>
                {s.phone && <p style={{ fontSize: '12px', color: 'var(--accent)' }}>{s.phone}</p>}
              </div>
              <div className="flex-between">
                <span className={`badge ${s.is_active ? 'badge-success' : 'badge-danger'}`}>{s.is_active ? 'Active' : 'Inactive'}</span>
                <button className="btn btn-outline btn-sm" onClick={() => openEdit(s)}><FiEdit /> Edit</button>
                  <button className="btn btn-outline btn-sm" onClick={() => handleDelete(s)} style={{ color: '#dc3545', borderColor: '#dc3545' }}>🗑️ Delete</button>
              </div>
            </div>
          ))}
          {staff.length === 0 && (
            <div className="card" style={{ gridColumn: '1/-1', textAlign: 'center', padding: '48px', color: '#999' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>👥</div>
              <p>Koi staff member nahi — Upar se add karein</p>
            </div>
          )}
        </div>

        {modal && (
          <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
            <div className="modal" style={{ maxWidth: '420px' }}>
              <div className="modal-header"><h3>{editId ? 'Staff Edit' : 'Naya Staff'}</h3><button className="modal-close" onClick={() => setModal(false)}><FiX /></button></div>
              <form onSubmit={handleSave}>
                <div className="form-group"><label className="form-label">Naam *</label><input className="form-control" value={form.name} onChange={e => set('name', e.target.value)} required /></div>
                <div className="form-group"><label className="form-label">Phone</label><input className="form-control" value={form.phone} onChange={e => set('phone', e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Role</label>
                  <select className="form-control" value={form.role} onChange={e => set('role', e.target.value)}>
                    {roleOptions.map(r => <option key={r}>{r}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={form.is_active} onChange={e => set('is_active', e.target.checked)} />
                    <span className="form-label" style={{ margin: 0 }}>Active</span>
                  </label>
                </div>
                <button className="btn btn-primary btn-full" type="submit">{editId ? '💾 Update' : '✅ Add Karein'}</button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
